<nb-card>
  <img [src]="imageURL" [style.width]="sWidth" [style.height]="sHeight" />
</nb-card>

<!-- <img [src]="imageURL" [style.width]="sWidth" [style.height]="sHeight" /> -->
